import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from "@angular/platform-browser";
import { bootstrapWithMsalRedirectBridge } from '@bayclubs/horizon';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

bootstrapWithMsalRedirectBridge(
    () => platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
        .catch(err => console.error(err))
);
